var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenderMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6C6.86 6 7.66667 6.27333 8.31333 6.74L11.72 3.33333H8.66667V2H14V7.33333H12.6667V4.27333L9.26 7.66667C9.72667 8.33333 10 9.13333 10 10C10 11.0609 9.57857 12.0783 8.82843 12.8284C8.07828 13.5786 7.06087 14 6 14C4.93913 14 3.92172 13.5786 3.17157 12.8284C2.42143 12.0783 2 11.0609 2 10C2 8.93913 2.42143 7.92172 3.17157 7.17157C3.92172 6.42143 4.93913 6 6 6ZM6 7.33333C5.29276 7.33333 4.61448 7.61428 4.11438 8.11438C3.61428 8.61448 3.33333 9.29276 3.33333 10C3.33333 10.7072 3.61428 11.3855 4.11438 11.8856C4.61448 12.3857 5.29276 12.6667 6 12.6667C6.70724 12.6667 7.38552 12.3857 7.88562 11.8856C8.38572 11.3855 8.66667 10.7072 8.66667 10C8.66667 9.29276 8.38572 8.61448 7.88562 8.11438C7.38552 7.61428 6.70724 7.33333 6 7.33333Z",
    fill: "#fb4646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMale);
export default __webpack_public_path__ + "static/media/genderMale.63665fac.svg";
export { ForwardRef as ReactComponent };